import './S_AnnotationStatus.scss';
import classNames from 'classnames';
import { ReactElement } from 'react';

interface IS_AnnotationStatusProps {
  text: string;
  className?: string;
}

export const S_AnnotationStatus = ({ className, text }: IS_AnnotationStatusProps): ReactElement => (
  <span className={classNames('annotation-status', className)}>{text}</span>
);
